<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                pestControlFileForm: () => import('../forms/PestControlFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [v => !!v || 'Facility is required'], isRequired: true, form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'text', text: 'Station Number', value: 'stationNumber', rules: [v => !!v || 'Station Number is required', v => !(v && v.length > 50) || 'Station Number must be less than 50 characters'], isRequired: true, maxLength: 50 },
                    { type: 'datetime', text: 'Placed On', value: 'placedOn', rules: [v => !!v || 'Placed On is required'], isRequired: true },
                    { type: 'textarea', text: 'Location Description', value: 'locationDescription', rules: [v => !!v || 'Location Description is required'], isRequired: true, maxLength: false },
                    { type: 'textarea', text: 'Type Description', value: 'typeDescription', rules: [v => !!v || 'Type Description is required'], isRequired: true, maxLength: false },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'pestControlId', form: () => import('../forms/PestControlFileForm') }
                ],
                apiMethod: 'PestControls',
                formTitle: 'Pest Control',
            }
        },
    };
</script>
